import { render, staticRenderFns } from "./Co39Page.vue?vue&type=template&id=d4730302"
import script from "./Co39Page.vue?vue&type=script&lang=js"
export * from "./Co39Page.vue?vue&type=script&lang=js"
import style0 from "./Co39Page.vue?vue&type=style&index=0&id=d4730302&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports